import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import App from './App';

function Redirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function Main() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route
          path="/quotes"
          element={
            <Redirect to="https://mixed-hound-c26.notion.site/Quotes-a56062b2bf7342ecb9c6edd9ec1c1d60" />
          }
        />
        <Route
          path="/writing"
          element={
            <Redirect to="https://mixed-hound-c26.notion.site/Public-Writing-05822ffe136345d28f1644947da5ce3d" />
          }
        />
        <Route
          path="/feedback"
          element={<Redirect to="https://www.admonymous.co/jonah-weinbaum" />}
        />
        <Route
          path="/anon"
          element={<Redirect to="https://www.admonymous.co/jonah-weinbaum" />}
        />
        <Route path="*" element={<App />} />
      </Routes>
    </Router>
  );
}

export default Main;
